import React, { useState } from "react";
import "./caseHighlights.css";
import { useNavigate } from "react-router-dom";
import {
  resetOnboardingInfo,
  updateOnboardingInfo,
} from "../../redux/attorneyOnboardingSlice";
import { useDispatch, useSelector } from "react-redux";
import BackIcon from "./assets/backIcon.png";
import NarrowDropdown2 from "../../components/input/new/narrowDropdown2";
import NarrowInputField from "../../components/input/new/narrowInputField";
import AddIcon from "./assets/addIcon.png";
import NarrowDropdownHierarchy from "../../components/input/new/narrowDropdownHierarchy";
import IconCheckbox from "../../components/input/new/iconCheckbox";
import StepFooter from "./stepFooter";
import RadioButton from "../../components/input/new/radioButton";
import { schools, degrees, positions } from "./schoolData";
import TextAreaWithCount from "../../components/input/new/textAreaWithCount";
import { practiceAreas } from "./schoolData";

const CaseHighlights = () => {
  const userId = useSelector(
    (state) => state.attorneyData.attorneyData?.user_id
  );

  const [caseHighlights, setCaseHighlights] = useState([]);

  const handleNext = () => {
    dispatch(
      updateOnboardingInfo({
        caseHighlights,
      })
    );
  };

  const addCaseHighlights = () => {
    setCaseHighlights((prev) => [
      ...prev,
      {
        caseTitle: "",
        practiceArea: "",
        role: "",
        year: "",
        description: "",
      },
    ]);
  };

  const removeCaseHighlights = (index) => {
    setCaseHighlights((prev) => {
      const newArray = prev.filter((_, i) => i !== index);
      // If the removed row was primary and there is at least one left, set the first one as primary.
      if (prev[index].primary && newArray.length > 0) {
        newArray[0].primary = true;
      }
      return newArray;
    });
  };

  const handleCaseHighlightChange = (index, field, value) => {
    setCaseHighlights((prev) => {
      const newArray = [...prev];
      newArray[index] = { ...newArray[index], [field]: value };
      return newArray;
    });
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBackToProfessionals = () => {
    // Optional extra logic here
    dispatch(resetOnboardingInfo());
    navigate(`/attorney/${userId}/home`);
  };

  return (
    <div className="education-container">
      {/* Breadcrumb / Navigation */}

      {/* Page Title */}

      <div className="category-profile-types">
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          <div className="category-breadcrumb" onClick={goBackToProfessionals}>
            <img
              src={BackIcon}
              alt="Back Icon"
              style={{ width: "24px", height: "24px" }}
            />
            <a className="category-back-link">Back to professionals</a>
          </div>
          <h1 className="education-title">
            Notable Case Highlights{" "}
            <span className="title-optional-disclaimer">(Optional)</span>
          </h1>

          <p className="education-second-title">Case Details</p>

          {/* Subtitle / Instructions */}
          <p className="education-subtitle">
            Add your most representative cases or matters that illustrate the
            quality and type of your experience.
          </p>

          {caseHighlights.map((caseH, index) => (
            <div key={index} className="education-row">
              <div className="education-row-header">
                <span className="education-number-title">
                  Education {index + 1}
                </span>
                <button
                  className="delete-education-btn"
                  onClick={() => removeCaseHighlights(index)}
                  title="Delete case"
                >
                  {/* You can use an icon here */}
                  Delete
                </button>
              </div>

              <NarrowInputField
                name="Case title"
                title="Case title"
                placeholder="Enter the case title"
                isRequired={true}
                value={caseH.firmName}
                onChange={(val) =>
                  handleCaseHighlightChange(
                    index,
                    "caseTitle",
                    val.target.value
                  )
                }
                halfWidth={false}
              />

              <NarrowDropdownHierarchy
                title="Practice area"
                placeholder="Choose an option"
                items={practiceAreas}
                isRequired={true}
                value={caseH.practiceArea}
                onChange={(val) =>
                  handleCaseHighlightChange(index, "practiceArea", val)
                }
                multiple={false}
                hierarchical={true}
              />

              <div
                style={{ display: "flex", alignItems: "center", gap: "20px" }}
              >
                <NarrowInputField
                  name="Your role"
                  title="Your role"
                  placeholder="Enter your role"
                  isRequired={true}
                  value={caseH.role}
                  onChange={(val) =>
                    handleCaseHighlightChange(index, "role", val.target.value)
                  }
                  halfWidth={true}
                />

                <NarrowInputField
                  name="Year"
                  title="Year"
                  placeholder="Enter the year"
                  isRequired={true}
                  value={caseH.year}
                  onChange={(val) =>
                    handleCaseHighlightChange(index, "year", val.target.value)
                  }
                  halfWidth={true}
                />
              </div>

              <TextAreaWithCount
                maxChars={2000}
                placeholder="Enter a description of the case here"
                value={caseH.description}
                onChange={(value) =>
                  handleCaseHighlightChange(
                    index,
                    "description",
                    value.target.value
                  )
                }
              />

              <hr className="h-rule" />
            </div>
          ))}

          <button className="education-add-button" onClick={addCaseHighlights}>
            <img
              src={AddIcon}
              style={{ width: "16px", height: "16px" }}
              alt="Add"
            />
            Add another case
          </button>
        </div>
      </div>

      <StepFooter
        currentStep={8}
        totalSteps={9}
        location="/attorney/setup/profile-photo"
        onNext={handleNext} // Pass handleNext function to the child
      />
    </div>
  );
};

export default CaseHighlights;
